(function () {
    'use strict';
    var controllerId = 'storeProductsListNewCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location', '$modal', '$routeParams','NgTableParams', storeProductsListNewCtrl]);
    function storeProductsListNewCtrl(common, datacontext, $scope, $location, $modal, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.search_text = "";
        vm.title = 'Product List View';
        $scope.save_search_edit = 0;
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            mp_notes_search:'',
            has_parent:'',
            store_product_status_id:'',
            store_id:'99',
            warehouse_id:'',
            description_status_id:'',
            category_id:'13',
            in_stock:'4',
            order_by:'sales_last_10_days',
            order_dir:'desc',
            fit_to_sell:'',
            is_active_override:'1',
            missingMinMax:'',
            synd_inv_error:'',
            synd_sync_timeout:'',
            is_oversize:'',
            marketplace_in_stock:'',
            synd_sync_fail:'',
            scrape_status_id:'',
            is_current_min_max_locked:'',
            is_current_price_rule_locked:'',
            current_price_rule_id:'',
            reprice_reason_id:'',
            last_on_hand:'',
            mp_last_inventory:'',
            search_category:1,
            sort_by:'',
            mp_inventory_sent:'',
            stock_level:'',
            product_license_region_id:'',
            asin_complete:'',
            asin_iscomplete_uk:'',
            our_sku:'',
            amz_sale_price:'',
            is_print_on_demand:'2',
            sales:'30',
            child_count:'',
            FNSKU:'',
            competitor_count:'',
            upc:'',
            multi_Qty:'',
            page:1,
            limit:20
        };

      //add url variables search
        if(angular.isDefined($routeParams.notoverselling)){
        	vm.query.marketplace_in_stock = 0;

        	vm.query.is_print_on_demand = 0;
        	vm.query.oversell = 1;
        	vm.query.product_lead_time = 1;
        	vm.query.is_orderable = 1;
        }

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                   // console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;

                    if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true){

                        if( i === 'save_search_list'){
                            console.log(vm.query.save_search_list);
                            get_store_products_sp_list_save_search();
                        }else{
                            get_store_products_sp_list();
                        }

                    }else{
                        return "";
                    }
                }
            }
        });

        activate();

        function activate() {
        	 if(angular.isDefined($routeParams.search_id)){
             	vm.query.save_search_list = $routeParams.search_id;
             	 var promises = [
             	                get_store_products_sp_list_save_search(),
             	                get_store_product_status(),
             	                get_store_product_scrape_status(),
             	                getProductCategories(),
             	                getManufacturers(),
             	                get_stores(),
             	                get_warehouses(),
             	                get_price_rules(),
             	                getProductStatus(),
                              getProductSource(),
             	                get_save_search(),
             	                get_reprice_reason(),
             	                get_min_max_logics(),
             	               get_license_region_list(),
                             get_shipping_regions(),
                             get_content_themes_list()
             	            ];
             	//();
             }else{
            	 var promises = [
            	                 get_store_products_sp_list(),
            	                 get_store_product_status(),
            	                 get_store_product_scrape_status(),
            	                 getProductCategories(),
            	                 getManufacturers(),
            	                 get_stores(),
            	                 get_warehouses(),
            	                 get_price_rules(),
            	                 getProductStatus(),
                               getProductSource(),
            	                 get_save_search(),
            	                 get_reprice_reason(),
            	                 get_min_max_logics(),
            	                 get_license_region_list(),
                               get_shipping_regions(),
                               get_content_themes_list()
            	             ];
             }

            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
            });
        }

        function get_store_product_status() {
            return datacontext.get_store_product_status().then(function(httpResult) {
                $scope.store_product_status = httpResult.data.data;

            });
        }
        function getProductSource() {
            return datacontext.get_product_source().then(function (httpResult) {
                vm.product_source = httpResult.data.data;
            });
        }
        function get_store_product_scrape_status() {
            return datacontext.get_store_product_scrape_status().then(function(httpResult) {
                vm.store_product_scrape_status = httpResult.data.data;
            });
        }

        function getManufacturers() {
            return datacontext.get_manufacturers().then(function (httpResult) {
                $scope.manufacturers = httpResult.data;
            });
        }

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function getProductStatus() {
            return datacontext.get_product_status().then(function (httpResult) {
                vm.product_status = httpResult.data.data;
            });
        }

        function get_save_search() {

            var data = {};
            data.search_category = 1;

            return datacontext.get_save_search(data).then(function (httpResult) {
                vm.save_search_list = httpResult.data.data;
            });
        }

        function get_warehouses() {
            return datacontext.get_warehouses().then(function(httpResult) {
                $scope.warehouses = httpResult.data.data;
            });
        }

        function get_price_rules() {
            return datacontext.get_price_rules().then(function(httpResult) {
                $scope.price_rules = httpResult.data.data;
            });
        }

        function get_reprice_reason() {
            return datacontext.get_reprice_reason().then(function(httpResult) {
                vm.reprice_reasons = httpResult.data.data;
            });
        }

        function get_min_max_logics() {
            return datacontext.get_min_max_rules().then(function(httpResult) {
                vm.min_max_logics = httpResult.data.data;
            });
        }

        function get_license_region_list() {
            return datacontext.get_license_region_list().then(function (httpResult) {
                console.log("httpResult",httpResult);
                vm.product_license_regions = httpResult.data;
            });
        }

        function get_content_themes_list() {
            return datacontext.get_content_themes_list().then(function (httpResult) {
                vm.content_themes = httpResult.data;
            });
        }

        function get_shipping_regions() {
            return datacontext.get_shipping_regions().then(function (httpResult) {
                vm.shipping_regions = httpResult.data.data;
            });
        }
        function get_store_products_sp_list_save_search() {
             var data = {
                search_id: vm.query.save_search_list,
                search_category:1
             };
            return datacontext.get_save_search(data).then(function(httpResult) {
                vm.save_search_data = httpResult.data.data;

                if(httpResult.data.RECORDCOUNT === 1){

                    sort_by(vm.save_search_data[0].sort_by);

                    vm.query.category_id = vm.save_search_data[0].category_id.toString();
                    vm.query.scrape_status_id = vm.save_search_data[0].scrape_status_id;
                    vm.query.store_id = vm.save_search_data[0].store_id.toString();
                    vm.query.store_product_status_id = vm.save_search_data[0].store_product_status_id.toString();
                    vm.query.is_active_override = vm.save_search_data[0].is_active_override.toString();
                    vm.query.fit_to_sell = vm.save_search_data[0].fit_to_sell.toString();
                    vm.query.warehouse_id = vm.save_search_data[0].warehouse_id.toString();
                    vm.query.in_stock = vm.save_search_data[0].in_stock.toString();
                    vm.query.marketplace_in_stock = vm.save_search_data[0].marketplace_in_stock.toString();
                    vm.query.is_oversize = vm.save_search_data[0].is_oversize.toString();
                    vm.query.is_print_on_demand = vm.save_search_data[0].is_print_on_demand.toString();
                    vm.query.missingMinMax = vm.save_search_data[0].missingminmax.toString();
                    vm.query.is_current_min_max_locked = vm.save_search_data[0].is_current_min_max_locked.toString();
                    vm.query.current_price_rule_id = vm.save_search_data[0].current_price_rule_id.toString();
                    vm.query.is_current_price_rule_locked = vm.save_search_data[0].is_current_price_rule_locked.toString();
                    vm.query.is_phantom = vm.save_search_data[0].is_phantom.toString();
                    vm.query.synd_sync_timeout = vm.save_search_data[0].synd_sync_timeout.toString();
                    vm.query.synd_inv_error = vm.save_search_data[0].synd_inv_error.toString();
                    vm.query.synd_sync_fail = vm.save_search_data[0].synd_sync_fail.toString();
                    vm.query.reprice_reason_id = vm.save_search_data[0].reprice_reason_id.toString();
                    vm.query.has_parent = vm.save_search_data[0].has_parent.toString();
                    vm.query.oversell = vm.save_search_data[0].oversell.toString();
                    vm.query.product_lead_time = vm.save_search_data[0].product_lead_time.toString();
                    vm.query.is_orderable = vm.save_search_data[0].is_orderable.toString();
                    vm.query.manufacturer_id = vm.save_search_data[0].manufacturer_id.toString();
                    vm.query.last_on_hand = vm.save_search_data[0].last_on_hand.toString();
                    vm.query.mp_last_inventory = vm.save_search_data[0].mp_last_inventory.toString();
                    vm.query.asin_iscomplete_uk = vm.save_search_data[0].asin_iscomplete_uk.toString();
                    vm.query.asin_complete = vm.save_search_data[0].asin_complete.toString();
                    vm.query.is_print_on_demand = vm.save_search_data[0].is_print_on_demand.toString();
                    vm.query.sales = vm.save_search_data[0].sales.toString();
                    vm.query.stock_level = vm.save_search_data[0].stock_level.toString();
                    vm.query.asin_iscomplete = vm.save_search_data[0].asin_iscomplete.toString();
                    vm.query.sort_by = vm.save_search_data[0].sort_by.toString();
                    vm.query.min_max_logic_id = vm.save_search_data[0].min_max_logic_id.toString();
                    vm.query.our_sku = vm.save_search_data[0].our_sku.toString();
                    vm.query.product_license_region_id = vm.save_search_data[0].product_license_region_id.toString();
                    vm.query.mp_inventory_sent = vm.save_search_data[0].mp_inventory_sent.toString();
                    //vm.query.order_by = 'store_product_id';
                    //vm.query.order_dir = 'desc';
                    vm.query.page = 1;
                    vm.query.limit = 20;

                }else{
                    vm.query = {
                        queryType:'array-count',
                        search:'',
                        has_parent:'',
                        store_product_status_id:'',
                        store_id:'',
                        warehouse_id:'',
                        description_status_id:'',
                        category_id:'',
                        order_by:'sales_last_10_days',
                        order_dir:'desc',
                        fit_to_sell:'',
                        is_active_override:'',
                        missingMinMax:'',
                        synd_inv_error:'',
                        synd_sync_timeout:'',
                        is_oversize:'',
                        marketplace_in_stock:'',
                        synd_sync_fail:'',
                        scrape_status_id:'',
                        is_current_min_max_locked:'',
                        is_current_price_rule_locked:'',
                        current_price_rule_id:'',
                        reprice_reason_id:'',
                        last_on_hand:'',
                        mp_last_inventory:'',
                        asin_complete:'',
                        asin_iscomplete_uk:'',
                        is_print_on_demand:'',
                        sales:'',
                        sort_by:'',
                        min_max_logic_id:'',
                        our_sku:'',
                        product_license_region_id:'',
                        stock_level:'',
                        mp_inventory_sent:'',
                        page:1,
                        limit:20
                    };
                }
               get_store_products_sp_list();
            });
        }

        function sort_by(idx) {

            switch(idx) {
                case '1':
                    vm.query.order_by = 'product_title';
                    vm.query.order_dir = 'asc';
                    break;
                case '2':
                    vm.query.order_by = 'product_title';
                    vm.query.order_dir = 'desc';
                    break;
                case '3':
                    vm.query.order_by = 'on_hand';
                    vm.query.order_dir = 'asc';
                    break;
                case '4':
                    vm.query.order_by = 'on_hand';
                    vm.query.order_dir = 'desc';
                    break;
                case '5':
                    vm.query.order_by = 'mp_available';
                    vm.query.order_dir = 'asc';
                    break;
                case '6':
                    vm.query.order_by = 'mp_available';
                    vm.query.order_dir = 'desc';
                    break;
                case '7':
                    vm.query.order_by = 'store_product_status';
                    vm.query.order_dir = 'asc';
                    break;
                case '8':
                    vm.query.order_by = 'store_product_status';
                    vm.query.order_dir = 'desc';
                    break;
                case '9':
                    vm.query.order_by = 'sales_last_30_days';
                    vm.query.order_dir = 'asc';
                    break;
                case '10':
                    vm.query.order_by = 'sales_last_30_days';
                    vm.query.order_dir = 'desc';
                    break;
                case '11':
                    vm.query.order_by = 'p_sales_last_30_days';
                    vm.query.order_dir = 'asc';
                    break;
                case '12':
                    vm.query.order_by = 'p_sales_last_30_days';
                    vm.query.order_dir = 'desc';
                    break;
                case '13':
                    vm.query.order_by = 'store_product_id';
                    vm.query.order_dir = 'asc';
                    break;
                case '14':
                    vm.query.order_by = 'store_product_id';
                    vm.query.order_dir = 'desc';
                    break;
                default:
                    vm.query.order_by = 'sales_last_10_days';
                    vm.query.order_dir = 'desc';
                    break;
            }

        }

        function get_store_products_sp_list() {

            sort_by(vm.query.sort_by);

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log(vm.query);
                    // ajax request to api
                    log_success("Searching");
                    return datacontext.get_store_products_sp_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;
                        vm.query.page = params.page;
                        console.log(httpResult.data.TOTAL);
                        //console.log(httpResult.data.total);
                        log_success(httpResult.data.TOTAL+" Results found !!!");
                        vm.results = [];
                        vm.results = httpResult.data;
                        	//console.log(vm.results);
                        	//console.log(vm.results.COLUMNS);

                        	  var col, i, r, _i, _len, _ref, _ref2, _results;
                        	  _results = [];
                        	  for (i = 0, _ref = vm.results.ROWCOUNT; 0 <= _ref ? i < _ref : i > _ref; 0 <= _ref ? i++ : i--) {
                        	    r = {};
                        	    _ref2 = vm.results.COLUMNS;

                        	    for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
                        	      col = _ref2[_i];
                        	      r[col.toLowerCase()] = vm.results.DATA[col][i];
                        	    }
                        	    _results.push(r);
                        	  }
                        	  //return _results;

                        	  vm.results = _results;

                        //console.log(_results);
                        return _results;
                    });
                }
            });
        }

        $scope.search = function(text) {
          console.log("text",text);
          if(text.length){
            vm.query.search = text;
          }else{
            vm.query.search = "";
          }
          get_store_products_sp_list();
        };

        //save search
        $scope.save_search = function(idx,save_search_edit,search_id) {
            console.log(vm.query);

            $scope.search = vm.query;
            $scope.search.save_search_edit = save_search_edit;
            $scope.search.search_id = search_id;

            if(save_search_edit){
                datacontext.check_temp_search({edit_search_id:search_id}).then(function (httpResult) {

                $scope.search.search_name = httpResult.data.data[0].search_name;
                console.log(httpResult.data.data[0].search_name);
                console.log('save_search name');
                console.log($scope.search.search_name);
                console.log($scope.save_search);
                console.log('done');
                });
                vm.query.edit_search_id = search_id;
            }

            datacontext.check_temp_search(vm.query).then(function (httpResult) {
                vm.check_temp_search = httpResult.data.COUNT;
                console.log("check_temp_search 1");
                console.log(httpResult);
                console.log(vm.check_temp_search);

                if(vm.check_temp_search == 0 || save_search_edit == 1){
                    var modalInstance = $modal.open({
                        templateUrl: '/app/storeproducts/partials/save_search.html',
                        controller: 'saveSearchCtrl',
                        windowClass: 'small',
                        resolve: {
                            save_search: function () {
                                return $scope.search;
                            }
                        }
                    }).result.then(function (result) {
                        $scope.$broadcast('refreshAuditLog', 'refresh');
                        get_save_search();
                    });
                }else{
                    log_error('Already Saved');
                }

            });

        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'saveSearchCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'save_search', saveSearchCtrl]);

    function saveSearchCtrl(common, datacontext, $scope, $modalInstance, save_search) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        $scope.save_search = save_search;

        if($scope.save_search.save_search_edit){
            $scope.search_name = save_search.search_name;
        }
        console.log($scope.save_search);

        var vm = this;

        $scope.ok = function (search_name, search_status, search_status_dashboard) {

            $scope.save_search.search_name = search_name;
            $scope.save_search.search_status = search_status;
            $scope.save_search.search_status_dashboard = search_status_dashboard;
            console.log($scope.save_search);

            if(search_name.length >= 100){
                log_error('Name is too long');
                return "";
            }

            var data = {};
            data.search_name = search_name;
            data.search_category = $scope.save_search.search_category;

            datacontext.check_temp_search(data).then(function (httpResult) {

                vm.check_temp_search = httpResult.data.COUNT;
                //console.log(vm.check_temp_search);

                if(vm.check_temp_search === 0 && $scope.save_search.save_search_edit == 0){
                    datacontext.ins_save_search($scope.save_search).then(function (httpResult) {

                        $scope.$broadcast('refreshAuditLog', 'refresh');
                        $modalInstance.close();

                        log_success('Saved');
                    });
                }else if($scope.save_search.save_search_edit == 1){

                    datacontext.update_save_search($scope.save_search).then(function (httpResult) {

                        $scope.$broadcast('refreshAuditLog', 'refresh');
                        $modalInstance.close();

                        log_success(httpResult.data.data);
                    });

                }else{
                    log_error('Name already Exists');
                }

            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'storeProductsListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies',  storeProductsListCtrl]);

    function storeProductsListCtrl(common, datacontext, $scope, $cookies) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.store_products = [];
        vm.title = 'Store Product View';
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
          console.log("vm.user_role_id:"+vm.user_role_id);
        }

        //todo make btn directive
        vm.updateSuccess = 0;
        vm.updateSubmitting = 0;
        vm.updateloading = 0;
        vm.bigCCheck = 1;

        if($scope.product_id.toString().indexOf('#') > 0) {
            $scope.product_id = $scope.product_id.toString().substring(0, $scope.product_id.toString().indexOf('#'));
            var filter = {
                       product_id:$scope.product_id};

	     } else {
	    	 var filter = {
	                 product_id:$scope.product_id};
	     }

        $scope.$on('refresh_storeProductsListCtrl', function (event, data) {
            console.log('run');
            activate();
        });

        activate();

        function activate() {
            var promises = [
                get_store_products(),
                get_store_product_status(),
                get_store_product_scrape_status(),
                get_stores(),
                get_warehouses(),
                get_vendor_id()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_store_product_status() {
            return datacontext.get_store_product_status().then(function(httpResult) {
                $scope.store_product_status = httpResult.data.data;
            });
        }

        function get_store_product_scrape_status() {
            return datacontext.get_store_product_scrape_status().then(function(httpResult) {

                vm.store_product_scrape_status = httpResult.data.data;
            });
        }
        function get_stores() {
            return datacontext.get_stores({"sup_store_id":2}).then(function(httpResult) {
                $scope.stores = httpResult.data.data;
            });
        }

        function get_warehouses() {
            return datacontext.get_warehouses().then(function(httpResult) {
                $scope.warehouses = httpResult.data.data;
                vm.fulfillment_warehouse_list = httpResult.data.data;
            });
        }

        function get_store_products() {
            return datacontext.get_store_products_p_list(filter).then(function(httpResult) {
                vm.store_products = httpResult.data.data;
                vm.manufacturer_id = httpResult.data.MANUFACTURER_ID;
                vm.spid_total_cnt = httpResult.data.TOTAL;
                $scope.add_store_products($scope.product_id);
                console.log(vm.store_products);
            });
        }


        function get_vendor_id() {
        	//console.log("filter:"+ filter.toString().split('#')[0] );

        	//console.log($scope);
            return datacontext.get_vendor_id(filter).then(function(httpResult) {
                vm.vendor_id = httpResult.data.data;
                console.log(vm.vendor_id);

            });
        }

        // Update Store Product
        $scope.update_store_product = function(idx) {
            // only update whats needed
            console.log(vm.store_products[idx]);
            if(vm.manufacturer_id !== 42 && vm.store_products[idx].store_id === 9){
                log_error("This is not PF manufacturer.");
                vm.error_message = "This is not PF manufacturer.";
            }else if(vm.manufacturer_id === 42 && vm.store_products[idx].store_id === 1){
                log_error("This is PF manufacturer on DL store.");
                vm.error_message = "This is PF manufacturer on DL store.";
            }else{
                vm.error_message = "";
            }
            
            if(vm.store_products[idx].store_product_id === 0){
                var spData = {
                                store_id:vm.store_products[idx].store_id,
                                store_product_id:vm.store_products[idx].store_product_id,
                                store_sku:vm.store_products[idx].store_sku,
                                product_id:vm.store_products[idx].product_id,
                                store_product_status_id:vm.store_products[idx].store_product_status_id,
                                warehouse_id:vm.store_products[idx].warehouse_id,
                                is_asin_moved: vm.store_products[idx].is_asin_moved
                            };
            } else{
                    var spData = {
                                    store_id:vm.store_products[idx].store_id,
                                    store_product_id:vm.store_products[idx].store_product_id,
                                    store_sku:vm.store_products[idx].store_sku,
                                    product_id:vm.store_products[idx].product_id,
                                    store_product_status_id:vm.store_products[idx].store_product_status_id,
                                    warehouse_id:vm.store_products[idx].warehouse_id
                                };
            }

            vm.store_products[idx].error = '';
            if(vm.store_products[idx].market_store_remember){
                $cookies.put('default_store', vm.store_products[idx].store_id);
            }

            if(vm.store_products[idx].market_store_remember_no){
                $cookies.remove('default_store');
                console.log("cookie removed");
            }

            /*
                if(angular.isDefined($cookies.get('default_store'))) {
                    console.log("cookie set");
                }
            */

            // Check if new product or old
            if (spData.store_product_id === 0) {
                vm.bigCCheck = 1;
                // insert product id into scope
                vm.store_products[idx].product_id = $scope.product_id;
                if(spData.store_id === 5){
                    datacontext.get_store_products_p_list({store_id: spData.store_id,search: vm.store_products[0].product_title,bigCCheck: 1}).then(function(response) {
                        if(response.data.data.length > 0) {
                            vm.bigCCheck = 0;
                            log_error("Cannot create Duplicate Store products for this store !!!");
                        }
                    });
                }

                if(vm.bigCCheck){
                    log_success("Creating New Store product");
                    datacontext.create_store_product(spData).then(function(response) {
                        if (response.data.success) {
                            // Pass
                            log_success("Created");
                            vm.store_products[idx].store_product_id = response.data.data;
                            vm.store_products[idx].success = 1;
                            get_store_products();
                        } else {
                            // Fail
                            log_error("Failed");
                            vm.store_products[idx].error = response.data.error;
                        }
                    });
                }
            } else {
                datacontext.update_store_product(spData).then(function(response) {
                    if (response.data.success) {
                        // Pass
                        vm.updateSubmitting = 0;
                        vm.store_products[idx].success = 1;
                        vm.updateSuccess = 1;
                    } else {
                        // Fail
                        vm.updateSubmitting = 0;
                        vm.store_products[idx].error = response.data.error;
                    }
                });
            }
            //get_store_products();
        };

        // Add Store Product
        $scope.add_store_products = function(product_id) {
            // todo fix default store HACK

            // Lookup manufacturer_id from product id
            var payload = {
                "product_id":product_id
            };

            datacontext.get_products(payload).then(function(httpResult) {
                //var store_id = 2;
                var store_id = 9;
                /*
                    if(vm.vendor_id === 26){
                        store_id = 1;
                    }
                */

                if (httpResult.data.data[0].manufacturer_id === 1 || httpResult.data.data[0].manufacturer_id === 15) {
                    store_id = 1;
                } else if (httpResult.data.data[0].manufacturer_id === 42){ //fix amazon store default value to PF
                    store_id = 9;
                }

                var store_id_cookie = 0;
                if(angular.isDefined($cookies.get('default_store'))) {
                    store_id = parseInt($cookies.get('default_store').trim());
                    store_id_cookie = 1;
                }

                console.log(vm.store_products);
                var no_need_to_add = 0
                for (var i in vm.store_products) {
                    for (var j in vm.store_products[i]) {
                        if(j === 'store_product_id' && vm.store_products[i][j] === 0){
                            var no_need_to_add = 1;
                            console.log(j +'--'+ vm.store_products[i][j]);
                        }
                    }
                }

                if(no_need_to_add === 0){
                    vm.store_products.unshift({
                        store_sku: '',
                        success: 1,
                        store_id: store_id,
                        store_id_cookie: store_id_cookie,
                        created_on: new Date(),
                        modified_on: new Date(),
                        product_id: $scope.product_id,
                        store_product_id: 0,
                        store_product_status_id:3,
                        market_store_remember:0
                    });
                    console.log(vm.store_products);
                }
            });
        };

        $scope.get_store_product_all = function(data){
            var filter = {
                product_id:$scope.product_id,
                show_inactive: 0
            };

            return datacontext.get_store_products_p_list(filter).then(function(httpResult) {
                vm.store_products = httpResult.data.data;
                $scope.add_store_products($scope.product_id);
            });
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'storeProductsDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$cookies', '$window', '$routeParams','$location','$timeout', '$anchorScroll', storeProductsDetailCtrl]);

    function storeProductsDetailCtrl(common, datacontext, $scope, $modal, $cookies, $window, $routeParams, $location,$timeout, $anchorScroll) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.store_products = [];
        vm.title = 'Store Product View';

        $scope.store_product_id = $routeParams.spid;

        vm.updateSubmitting = 0;
        vm.updateSuccess = 0;
        vm.updateError = 0;

        $scope.msc = {
            isLoading:0
        };
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
          console.log("vm.user_role_id:"+vm.user_role_id);
        }
        // setting for audit log
        $scope.audit_link_id = $routeParams.spid;
        $scope.audit_type_id = 3;

        activate();

        function activate() {
            var promises = [
                get_store_product_detail(),
                //get_store_product_status(),
                get_store_product_scrape_status(),
                get_stores(),
                get_marketplace_upload_log(),
                get_warehouses(),
                get_price_rules(),
                get_aws_variation_themes(),
                get_reprice_reason(),
                get_shipping_regions(),
                get_faire_variants()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    //log('Activated Store product List View');
                });
        }

        /*function get_store_product_status() {
            return datacontext.get_store_product_status().then(function(httpResult) {
                vm.get_store_product_status = httpResult.data.data;
            });
        }*/

        function get_store_product_scrape_status() {
            return datacontext.get_store_product_scrape_status().then(function(httpResult) {
                vm.store_product_scrape_status = httpResult.data.data;
            });
        }

        function get_marketplace_upload_log() {
            $scope.type_id = 2;
            return datacontext.get_marketplace_upload_log($scope.type_id, $scope.store_product_id).then(function(httpResult) {
                $scope.marketplace_upload_log = httpResult.data.data;

            });
        }

        function get_store_product_detail() {
            var filter = {
                store_product_id:$scope.store_product_id
            };
            return datacontext.get_store_product_detail(filter).then(function(httpResult) {
                vm.product = httpResult.data.data[0];
                vm.product.store_product_status_id_prev = vm.product.store_product_status_id;
                vm.product.sale_start_date = new Date(vm.product.sale_start_date);
                vm.product.sale_end_date = new Date(vm.product.sale_end_date);
                console.log("vm.product.restock_date1before:"+vm.product.restock_date_v1);
                var fulldate = new Date(vm.product.restock_date_v1);
                var yearPart = fulldate.getFullYear();
                var monthPart = fulldate.getMonth();
                var DatePart = fulldate.getDate();
                vm.product.restock_date= new Date(yearPart, monthPart, DatePart, 0, 0, 0);
                console.log("vm.product.restock_date:"+vm.product.restock_date);
                vm.product.sp_details = 1;
                /*console.log("vm.product.restock_datebefore:"+vm.product.restock_date_v1);
                vm.product.restock_date = new Date(vm.product.restock_date_v1);
                console.log("vm.product.restock_date:"+vm.product.restock_date);*/
                vm.product.notes_new = "";
            });
        }

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function get_warehouses() {
            return datacontext.get_warehouses().then(function(httpResult) {
                vm.warehouse_list = httpResult.data.data;
            });
        }

        function get_price_rules() {
            return datacontext.get_price_rules().then(function(httpResult) {
                vm.price_rules = httpResult.data.data;
            });
        }

        function get_aws_variation_themes() {
            return datacontext.get_aws_variation_themes().then(function(httpResult) {
                vm.aws_variation_themes = httpResult.data.data;
            });
        }

        function get_reprice_reason() {
            return datacontext.get_reprice_reason().then(function(httpResult) {
                vm.reprice_reasons = httpResult.data.data;
            });
        }

        function get_shipping_regions() {
            return datacontext.get_shipping_regions().then(function (httpResult) {
                vm.shipping_regions = httpResult.data.data;
            });
        }

        function get_faire_variants() {
            return datacontext.get_faire_variants($scope.store_product_id).then(function (httpResult) {
                vm.faire_variants = httpResult.data.data;
            });
        }

        $scope.msc.isLoading = 0;
        $scope.marketplace_scrape_check = function(store_product_id,marketplace_id) {

            if(marketplace_id == 1){
                var url = 'https://cvx8sfyh08.execute-api.us-east-1.amazonaws.com/beta/marketplace-scrape/';
            }else if(marketplace_id == 2){
                var url = 'https://cvx8sfyh08.execute-api.us-east-1.amazonaws.com/beta/scrape-ebay/';
            }else if(marketplace_id == 5){
                var url = 'https://cvx8sfyh08.execute-api.us-east-1.amazonaws.com/beta/scrape-walmart/';
            }else {
                return "";
            }

            $scope.msc.isLoading = 1;

            return datacontext.marketplace_scrape_check({"store_product_id":store_product_id},url).then(function(httpResult) {
                $scope.msc.isLoading = 0;
                // refresh
                get_store_product_detail();
                log_success('Scrape status Updated');
            });
        };

        $scope.msc.isLoading = 0;
        $scope.image_format_update = function(store_product_id) {

            $scope.msc.isLoading = 1;

            var url = 'https://ace.gothamcityonline.com/tasks/image/image_format.cfm?spid='+store_product_id+'&update_status=1';

            return datacontext.image_format_update(url).then(function(httpResult) {
                $scope.msc.isLoading = 0;
                // refresh
                get_store_product_detail();
            });
        };

        $scope.resetSync = function(idx) {

            var data = {};
            data.store_product_id = $scope.store_product_id;

            switch(idx) {
                case 'image_sync_on':
                    data.image_sync_on = '';
                    break;
                case 'inventory_sync_on':
                    data.inventory_sync_on = '';
                    break;
                case 'desc_sync_on':
                    data.desc_sync_on = '';
                    break;
                case 'price_sync_on':
                    data.price_sync_on = '';
                    break;
                case 'synd_failure_cnt':
                    data.synd_failure_cnt = 0;
                    break;
                case 'gcid_desc_on':
                    data.gcid_desc_on = '';
                    data.desc_sync_on = '';
                    break;
                case 'mp_notes':
                    data.mp_notes = '';
                    data.reset_note = 1;
                    break;
                case 'note':
                    data.note = '';
                    data.reset_user_note = 1;
            }

            datacontext.update_store_product(data).then(function() {
                //  update audit table
                get_store_product_detail();
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });
        };

        vm.mwsFullLookup = function(data) {

            var payload = {
                asin: data.store_sku,
                store_product_id: data.store_product_id,
                store_id: data.store_id
            };
            return datacontext.mwsFullLookup(payload).then(function(httpResult) {
                // refresh
            	console.log(httpResult);
            	console.log(httpResult.data.success);
            	console.log(httpResult.data);
                if ( httpResult.data.success ) {
                    get_store_product_detail();
                } else  {
                    // failure
                    log('asin not found on amazon');
                }

            });
        };

        $scope.create_phantom = function (data) {

            $scope.payload = {
                data: data,
                step: 1
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/amz_phantom_create_modal.html',
                controller: 'createPhantomModalCtrl',
                resolve: {
                    payload: function () {
                        return $scope.payload;
                    }
                }
            }).result.then(function(result){
                activate();
            });

            $scope.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.create_product_relationship = function (payload) {
            return datacontext.create_product_relationship(payload).then(function () {
                getProductRelationships();
            });
        };

        // Update Store Product
        $scope.update_store_product = function(data) {

            vm.updateSubmitting = 1;
            vm.updateSuccess = 0;
            vm.product.sp_details = 1;

            if(data.store_id === 8 && data.store_product_status === "active"){
              //  return "";
                datacontext.walmart_push_product(data).then(function(response) {

                    get_store_product_detail();
                    $scope.$broadcast('refreshAuditLog', 'refresh');

                    log_success('Updated in Walmart');
                 });
            }

            //todo hardcode vars to update
            // datacontext.update_store_product(data).then(function(response) {
            
            var payload = angular.copy(data);
            delete payload.from_inactive_list_date;

            datacontext.update_store_product(payload).then(function(response) {

                vm.updateSubmitting = 0;
                vm.updateSuccess = 1;

                if (response.data.success) {
                    // Pass
                    get_store_product_detail();
                    $scope.$broadcast('refreshAuditLog', 'refresh');

                } else {
                    // Fail
                    vm.updateError = 1;
                    vm.product.error = response.data.error;
                }

            });
        };

        $scope.calc_mp_avail_no_qtytosell_check = function(){

        	var payload = {
        			 store_product_id: $scope.store_product_id
                 };
        	datacontext.calc_mp_avail_no_qtytosell_check(payload).then(function(response) {

                if (response.data.success) {
                    // Pass
                	window.location.reload();

                } else {
                    // Fail
                	window.location.reload();

                }

            });
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'repriceDetailsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location','NgTableParams', repriceDetailsCtrl]);
    function repriceDetailsCtrl(common, datacontext, $scope, $routeParams, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Product List View';

        // create empty structure for search items
        vm.query = {
            queryType:'array',
            store_product_id:$routeParams.spid
        };

        vm.urlQuery  = $location.search();

        // setting for audit log
        $scope.audit_link_id = $routeParams.pid;
        $scope.audit_type_id = 3;
        $scope.audit_sub_type_id = 3;

        activate();


        function activate() {
            var promises = [
                get_store_products(),
                get_reprice_cnt()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_store_products() {
            // ajax request to api
            return datacontext.get_store_products(vm.query).then(function (httpResult) {
                $scope.item = httpResult.data.data[0];
            });
        }

        function get_reprice_cnt() {
            // ajax request to api
            return datacontext.get_reprice_cnt(vm.query).then(function (httpResult) {
                $scope.item_cnt = httpResult.data.data;
            });
        }


    }
})();
(function () {
    'use strict';
    var controllerId = 'repriceWalDetailsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location','NgTableParams', repriceWalDetailsCtrl]);
    function repriceWalDetailsCtrl(common, datacontext, $scope, $routeParams, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Product List View';

        // create empty structure for search items
        vm.query = {
            queryType:'array',
            store_product_id:$routeParams.spid
        };

        vm.urlQuery  = $location.search();

        // setting for audit log
        $scope.audit_link_id = $routeParams.pid;
        $scope.audit_type_id = 3;
        $scope.audit_sub_type_id = 3;

        activate();


        function activate() {
            var promises = [
                get_wal_reprice()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_wal_reprice() {
            // ajax request to api
            return datacontext.get_wal_reprice(vm.query).then(function (httpResult) {
                vm.repricer = httpResult.data.data;
                vm.status = httpResult.data.STATUS;
                console.log($scope.repricer);
            });
        }

    }
})();


(function() {
    'use strict';
    var controllerId = 'storeProductPriceHistoryCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$routeParams', 'NgTableParams', storeProductPriceHistoryCtrl]);

    function storeProductPriceHistoryCtrl(common, datacontext, $scope, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        // Pushes input to scope
        $scope.store_product_id = $routeParams.spid;

        vm.query = {
            queryType:'array-count',
            store_product_id: $routeParams.spid,
            page:1,
            limit:20
        };

        activate();

        function activate() {
            var promises = [
                get_product_sale_history()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_product_sale_history() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_product_sale_history(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();


(function() {
    'use strict';
    var controllerId = 'rePriceHistoryCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$routeParams', 'NgTableParams', rePriceHistoryCtrl]);

    function rePriceHistoryCtrl(common, datacontext, $scope, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        // Pushes input to scope
        $scope.store_product_id = $routeParams.spid;
        console.log($scope);
        console.log($routeParams);
        vm.query = {
            queryType:'array-count',
            store_product_id: $routeParams.spid,
            page:1,
            limit:20,
            order_by: 'id',
            order_dir:'desc'
        };

        vm.lookbackQuery = {
            queryType:'array-count',
            store_product_id: $routeParams.spid,
            tzOffset: moment().utcOffset(),
            page:1,
            limit:50,
            order_by: 'id',
            order_dir:'desc'
        };

        activate();

        function activate() {
            var promises = [
                get_reprice_history(),
                get_24hr_reprice_history()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_24hr_reprice_history() {
          vm.lookbackQuery = {
              queryType:'array',
              store_product_id: $routeParams.spid,
              tzOffset: moment().utcOffset(),
              page:1,
              limit:50,
              order_by: 'id',
              order_dir:'desc'
          };
            return datacontext.get_reprice_history(vm.lookbackQuery).then(function (httpResult) {

                // reverse array for ordering
                var r = httpResult.data.data.reverse();

                var labels = [];
                var us = [];
                var them = [];

                $scope.ageData = [];

                for ( var i in r ) {
                    labels.push(r[i].created_on_ts.toString() + '');
                    us.push(r[i].newpricetotal1);
                    them.push(r[i].competitorprice);
                }

                $scope.series = ["Our Price", "Competitor"];
                $scope.ageLabels = labels;
                $scope.ageData.push(us);
                $scope.ageData.push(them);

            });

        }

        function get_reprice_history() {


            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    console.log('running 2');


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_reprice_history(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);


                        console.log(httpResult);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.store_id = httpResult.data.STORE_ID;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;

                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'nightRePriceHistoryCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location','NgTableParams', nightRePriceHistoryCtrl]);
    function nightRePriceHistoryCtrl(common, datacontext, $scope, $routeParams, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.query = {
                store_product_id: $routeParams.spid

            };
        activate();

        function activate() {
            var promises = [
                get_night_reprice()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_night_reprice() {
            // ajax request to api
            return datacontext.get_night_reprice(vm.query).then(function (httpResult) {
            	vm.audit_log = httpResult.data.data;

            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'storeProductSalesCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location', '$cookies','NgTableParams', storeProductSalesCtrl]);
    function storeProductSalesCtrl(common, datacontext, $scope, $routeParams, $location, $cookies, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Product List View';

        // create empty structure for search items
        /*if(angular.isDefined($cookies.get('default_store'))) {
        	vm.query = {
                    queryType:'array-count',
                    product_id:$routeParams.pid,
                    order_by:'store_product_id',
                    order_dir:'asc',
                    page:1,
                    limit:80
                };
        }else{*/
        	vm.query = {
                    queryType:'array-count',
                    product_id:$routeParams.pid,
                    order_by:'sales_last_10_days Desc, sp.store_product_status_id',
                    order_dir:'asc',
                    page:1,
                    limit:80,
                    single_spid: 1
                };
        //}


        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // setting for audit log
        $scope.audit_link_id = $routeParams.pid;
        $scope.audit_type_id = 3;
        $scope.audit_sub_type_id = 3;

        	activate();

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    // if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true){
                    if( oldValue[i] >= 0 || oldValue[i] == "" || oldValue[i] < 0 || angular.isUndefined(oldValue[i])  == true ){
                        get_store_products();
                    }else{
                        return '';
                    }
                }
            }
        });

        function activate() {
            var promises = [
                get_store_products()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_store_products() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
              getData: function(params) {
                  vm.query.page = params.page;

                  for(var key in params.sorting()) {
                    vm.query.order_by = key;
                    vm.query.order_dir = params.sorting()[key];
                  }

                  if( vm.query.order_by == '' && vm.query.order_dir == ''){
                    
                        vm.query.order_by = 'ifnull(sp.sales_last_10_days,0) Desc, sps.store_product_status asc';
                        vm.query.order_dir = ''; 
                  }
                                    
                  vm.query.pid_price_sale = 1;
                  // ajax request to api
                  return datacontext.get_store_products(vm.query).then(function (httpResult) {
                      //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                      params.total(httpResult.data.total);
                      vm.results_total = httpResult.data.total;
                      vm.query.page = params.page;
                      // set new data
                      vm.results = httpResult.data.data;
                      return httpResult.data.data;
                  });
              }
            });
        }
    }
})();



(function () {
    'use strict';
    var controllerId = 'minMaxRulesCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location','NgTableParams', minMaxRulesCtrl]);
    function minMaxRulesCtrl(common, datacontext, $scope, $routeParams, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        activate();


        function activate() {
            var promises = [
                get_min_max_rules()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_min_max_rules() {
            // ajax request to api
            return datacontext.get_min_max_rules(vm.query).then(function (httpResult) {
                vm.min_max_rules = httpResult.data.data;
            });
        }
    }
})();


(function() {
    'use strict';
    var controllerId = 'statusnotesCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','payload', statusnotesCtrl]);

    function statusnotesCtrl(common, datacontext, $scope, $modalInstance, payload) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);


    }
})();
